import React from "react";
import { PageParams } from "../../model/search/UserSearchRequestV1";
import { PageProps } from "../../model/views/PageProps";

interface PageNotFoundPageContentProps extends PageProps {}

export function PageNotFoundPageContent(props: PageNotFoundPageContentProps) {
  return <div className="main-container">Not found</div>;
}
